import { confirm, DialogResponse } from 'owa-confirm-dialog';
import workaroundFocusIssueForFirefox from 'owa-editor-plugin-utils/lib/utils/workaroundFocusIssueForFirefox';
import loc from 'owa-localize';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import { okButton } from 'owa-locstrings/lib/strings/okbutton.locstring.json';
import * as React from 'react';
import { setNumberingValueDialogTitle, setValueTo } from './SetNumberingValueDialog.locstring.json';

import styles from './setNumberingValueDialog.scss';

export type DisplaySetNumberingDialogInput = {
    value: number;
};

export default function displaySetNumberingDialog(
    input: DisplaySetNumberingDialogInput,
    targetWindow: Window
): Promise<DialogResponse> {
    let displayTextInput: HTMLInputElement | null;

    const onNumberInputChange = () => {
        input.value = parseInt(displayTextInput?.value ?? '1');
    };

    workaroundFocusIssueForFirefox(document);

    const bodyContent = (
        <div className={styles.numberingContent}>
            <div className={styles.displayTextInputBox}>
                <label htmlFor="displayTextInput">{loc(setValueTo)}</label>
                <input
                    id="displayTextInput"
                    role="textbox"
                    type="number"
                    ref={ref => (displayTextInput = ref)}
                    min={'1'}
                    defaultValue={input.value.toString() ?? '1'}
                    className={styles.numberingInput}
                    onChange={onNumberInputChange}
                />
            </div>
        </div>
    );

    return confirm(
        loc(setNumberingValueDialogTitle),
        undefined /*subText*/,
        false /*resolveImmediately*/,
        {
            targetWindow,
            okText: loc(okButton),
            cancelText: loc(cancelButton),
            bodyElement: bodyContent,
            delayCallbackAfterAnimation: true,
            containerClassName: styles.numberingDialog,
            focusSelector: '#setNumberingInput',
        }
    );
}
